import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as activityActions from '../actions/activity';
import Modal from './CustomModal';
import ReadMore from '../components/readMore';
import ListingButtons from '../components/listingButtons';
import ListingModalComments from '../components/listingModalComments';
import PropTypes from 'prop-types';
import { getFormattedCurrency, getFormattedNumber } from '../components/utils';
import { buildOpenHouseBar, displayListingPrice } from './listingDetailsHelpers';
import classNames from 'classnames';
// styles
import '../scss/_listingCard.scss';
import '../scss/_listingModal.scss';
import '../scss/_activityComment.scss';
// svg
import bed from '../images/icons/bed.svg';
import bath from '../images/icons/bath.svg';
import ruler from '../images/icons/ruler.svg';
import acres from '../images/icons/lotAcres.svg';
import calendar from '../images/icons/calendar.svg';
import crossbutton from '../images/icons/cross-white.svg';
// svg icons
import { ReactComponent as Expand } from '../images/svg_icons/expand.svg'
import { modalView } from '../components/GoogleAnalytics';
import KnowMore from './AgentBusinessCardMini/KnowMore';
import PhotoCarousel from './PhotoCarousel';

class listingModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            readMoreExpanded: false
        };
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal = () => {
        this.props.toggle('listingModal');
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.listing && nextProps.listing &&
            this.props.listing.ActivityId !== nextProps.listing.ActivityId) {
            // Activity Id has changed
            this.props.activityActions.fetchSingleActivity(nextProps.listing.ActivityId);
        }
    }

    componentDidMount() {
        // Check that the listing exists
        if (!this.props.listing && this.props.listingId)
            this.props.listingActions.fetchListingById(this.props.listingId);

        // Check that the activity entity exists
        if (this.props.listing && this.props.listing.ActivityId) {
            const act = this.props.activities[this.props.listing.ActivityId];
            if (act === undefined) {
                // We have an ActivityId but it was not found
                this.props.activityActions.fetchSingleActivity(this.props.listing.ActivityId);
            }
        }

        // Register Modal open with Google Analytics
        if (this.props.listingId)
            modalView('listingModal?listingid=' + this.props.listingId);
        else if (this.props.ActivityId)
            modalView('listingModal?activityid=' + this.props.ActivityId);
    }

    render() {
        const { listing, listingId, activities } = this.props;
        const { readMoreExpanded } = this.state;
        const externalCloseBtn = <button className="close dyna-close" onClick={() => this.closeModal()}>
            <img src={crossbutton} alt="close" />
        </button>;
        const slashedPrice = <div className="listing_price_slashed">{getFormattedCurrency(listing.OriginalListPrice)}</div>;
        let comments = null;

        // Check that the listing exists
        if (!listing)
            return <div></div>

        if (listing.ActivityId) {
            const activity = activities[listing.ActivityId];
            if (activity)
                comments = activity.Comments;
        }

        return <Modal modalIsOpen={this.props.modalIsOpen}
            external={externalCloseBtn}
            handleClose={() => this.closeModal()}
            className="dyna-modal modal-xl no-gutters" bodyClass="pd-top-0">
            <div className="">
                <div className="listingModal" style={{ display: 'flex' }}>
                    <div className="listingModal_carousel">
                        <PhotoCarousel listing={listing} />
                        <div className="photo-badges">
                            {buildOpenHouseBar(listing)}
                        </div>
                    </div>
                    <div className="listing_folder mg-btm-0 pos-rel">
                        <div className="address">
                            <div>
                                <button className="btn-link d-flex" onClick={() => window.open(this.props.publicPortal ? `/listing-details/public-portal/${listingId}` : `/listing-details/${listingId}`)}>
                                    <h5 className="pd-rt-5">{`${listing.StreetAddress}`}</h5><Expand />
                                </button>
                                {listing.City}, {listing.State} {listing.Zip}
                                <div>Listing ID: {listing.ListingId}</div>
                            </div>
                            <div className="listing_price">
                                <div className={!listing.PriceTypeLabel && listing.OriginalListPrice && listing.OriginalListPrice !== listing.ListPrice ? "listing_price" : "listing_price_grey"}>
                                    {displayListingPrice(listing, true)}
                                    {!listing.PriceTypeLabel && listing.OriginalListPrice && listing.OriginalListPrice !== listing.ListPrice ? slashedPrice : null}
                                </div>
                            </div>
                            <div className={classNames("listing_remarks mg-top-10 overflow-auto-at-180", { 'break-word': readMoreExpanded })}>
                                <ReadMore
                                    lines={3}
                                    onToggleLines={(expanded) => this.setState({ readMoreExpanded: expanded })}>
                                    {listing.Remarks}
                                </ReadMore>
                            </div>
                            <div className="listing_icons">
                                {listing.BedroomsTotal > 0 && <div><img src={bed} alt="bed" /> {listing.BedroomsTotal}</div>}
                                {listing.BathroomsFull > 0 && <div><img src={bath} alt="bath" /> {listing.BathroomsFull} </div>}
                                {listing.SquareFeet > 0 && <div><img src={ruler} alt="ruler" /> {getFormattedNumber(listing.SquareFeet)} sqft</div>}
                                {listing.YearBuilt && <div> <img src={calendar} alt="calendar" /> built {listing.YearBuilt}</div>}
                                {listing.PropertyType === "LL" && listing.Acres && listing.Acres > 0 && <div> <img src={acres} alt="acres" /> {listing.Acres} acres</div>}
                            </div>
                            {/* placeholder hack that maintains card width when no above icons or description */}
                            {/* <div style={{ visibility: "hidden", height: "0px" }}>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                            </div> */}
                        </div>
                        <ListingButtons listingActions={this.props.listingActions} listing={listing} isModal={true}></ListingButtons>
                        <div style={{ height: '100%' }} className={classNames("activity activity_overflow_auto", { 'read-more-expanded': readMoreExpanded })}>
                            {
                                this.props.publicPortal
                                    ? <div style={{ padding: '16px', height: '100%' }}><KnowMore onContactAgent={this.props.onContactAgent} /></div>
                                    : <ListingModalComments
                                        listing={listing}
                                        comments={comments}
                                        myProfile={this.props.myProfile}
                                        showNotification={this.props.showNotification}
                                        userPhotoList={[]} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    }
}

const mapStateToProps = (state, props) => ({
    //agentProfile: state.profile.agent
    myProfile: state.profile.mine || {},
    activities: state.entities.Activities || {},
    listings: state.entities.Listings,
    listing: state.entities.Listings[props.listingId]
});

const mapDispatchToProps = dispatch => ({
    activityActions: bindActionCreators(activityActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(listingModal);

listingModal.propTypes = {
    listingActions: PropTypes.any.isRequired
};